export const underwearsQueryKeys = {
  all: ['underwears'] as const,
};
